import React from 'react'
import ProspectsBase from './ProspectsBase'

class PropectsIndex extends React.Component {

  render() {
    return (
      <ProspectsBase {...this.props} user_type="user"/>
    )
  }
}

export default PropectsIndex



// WEBPACK FOOTER //
// ./src/js/components/ProspectsIndex.js